export const columns = ({ t }) => [
  {
    title: t('Id'),
    name: 'id'
  },
  {
    title: t('Name'),
    name: 'name'
  },
  {
    title: t('External Id'),
    name: 'externalId'
  }
];

export const formatData = organizations =>
  organizations.map(org => ({
    ...org
  }));

export default {
  columns,
  formatData
};
